<template>
    <div>
        <div v-if="!showToggle">
            <button class="btn btn-info" @click="toggleRegSelect">Go Back To Registration Rates</button>
            <br><br>
        </div>
        <div class="reg-select" style="background-color: #b7b7b71c; padding: 15px; border-radius: 5px"
             v-if="showToggle">

            <div class="table-responsive" v-for="cat in state.meetingData.reg_type_cat">
                <h3>{{cat}}</h3>
                <table class="table table-condensed">
                    <thead>
                    <tr>
                        <th style="text-align: left" scope="col">Registration Type</th>
                        <th scope="col">Price</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="reg in state.meetingData.reg_type" v-if="reg.name === cat">
                        <td style="text-align: left" scope="row">{{reg.type}} <span v-if="reg.details"><br>({{reg.details}})</span>
                        </td>
                        <td>${{reg.regularPrice}}</td>
                        <td><input @change="setShow" name="regSelect" type="radio"
                                   @click="updateRegType(reg)"></td>

                    </tr>
                    </tbody>
                </table>
            </div>

        </div>

    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import GuestTickets from './GuestTickets'

    export default {
        name: 'RegSelect',
        data: function () {
            return {
                formstate: {},
                showToggle: true
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
        },
        methods: {
            toggleRegSelect() {
                this.showToggle = !this.showToggle;
            },
            updateRegType(reg) {
              this.$store.commit('updateRegType', reg);
              this.$store.commit('removePromoVal');
            },
            setShow() {
                this.showToggle = !this.showToggle;
                if (this.state.registrantData.regType) {
                    this.state.showSection = {
                        medical: false,
                        trainee: false,
                        oneDay: false,
                        industry: false,
                    };

                    const groupsRequired = this.state.registrantData.regType.extraFieldGroupsRequired;
                    groupsRequired.filter((group) => {
                        this.state.showSection[group] = true;
                    });
                }
                this.$store.commit('updateTotal')
            },
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },

        },
        components: {
            GuestTickets,
        }
    }
</script>

<style scoped>
/* Registration layout */
.reg-select {
  display: grid;
  grid-template-columns: repeat(
        auto-fit,
        minmax(min(100%, 420px), 1fr)
    );
  align-items: start;
  gap: 24px;

  padding: 26px !important;
  background: linear-gradient(
      135deg,
      #e2f4f2 0%,
      #edf1fa 55%,
      #e6e4f5 100%
  ) !important;

  border: 1px solid #cbdce6;
  border-radius: 20px !important;
  box-shadow: 0 10px 30px rgba(49, 75, 111, 0.10);
}

.reg-select,
.reg-select * {
  box-sizing: border-box;
}

/* Individual category cards */
.reg-select .table-responsive {
  min-width: 0;
  width: 100%;
  margin: 0;
  overflow-x: auto;

  background: #ffffff;
  border: 1px solid #d5deec;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(49, 75, 111, 0.12);

  -webkit-overflow-scrolling: touch;
}

/* Teal-to-indigo category headings */
.reg-select .table-responsive > h3 {
  margin: 0;
  padding: 22px 24px;

  background: linear-gradient(
      110deg,
      #148f94 0%,
      #427f9e 50%,
      #656dac 100%
  );

  border-bottom: 4px solid #80c9c5;
  color: #ffffff;

  font-family: inherit;
  font-size: 22px;
  font-weight: 300;
  line-height: 1.35;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}

/* Alternate category accent */
.reg-select .table-responsive:nth-child(even) > h3 {
  background: linear-gradient(
      110deg,
      #5666a2 0%,
      #517fa3 50%,
      #198f96 100%
  );

  border-bottom-color: #a8b1de;
}

/* Table base */
.reg-select .table {
  width: 100%;
  margin: 0;
  border: 0;
  border-collapse: collapse;
  background: #ffffff;

  color: #535c98;
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
}

/* Table column headings */
.reg-select .table thead th {
  padding: 15px 18px;
  border: 0;
  border-bottom: 2px solid #d9e2ef;
  background: #edf1f8;

  color: #4c5d82;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: 0.06em;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
}

.reg-select .table thead th:first-child {
  padding-left: 24px;
  text-align: left;
}

.reg-select .table thead th:nth-child(2) {
  width: 110px;
  background: #e5e8f7;
  color: #505a91;
}

.reg-select .table thead th:last-child {
  width: 64px;
  background: #deefee;
}

/* Uniform registration and price text */
.reg-select .table tbody td {
  padding: 20px 18px;
  border: 0;
  border-bottom: 1px solid #e1e7ef;

  color: #535c98;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  vertical-align: middle;

  transition: background-color 0.18s ease;
}

.reg-select .table tbody td:first-child {
  padding-left: 24px;
  background: #ffffff;
  text-align: left;
}

.reg-select .table tbody tr:nth-child(even) td:first-child {
  background: #f5f8fc;
}

/* Registration details inherit the same typography */
.reg-select .table tbody td:first-child span {
  display: inline-block;
  margin-top: 4px;

  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

/* Lavender price column */
.reg-select .table tbody td:nth-child(2) {
  width: 110px;
  background: #f0effa;
  text-align: center;
  white-space: nowrap;
}

.reg-select .table tbody tr:nth-child(even) td:nth-child(2) {
  background: #e8e7f6;
}

/* Teal selection column */
.reg-select .table tbody td:last-child {
  width: 64px;
  background: #edf8f6;
  text-align: center;
}

.reg-select .table tbody tr:nth-child(even) td:last-child {
  background: #e2f2ef;
}

.reg-select .table tbody tr:last-child td {
  border-bottom: 0;
}

/* Highlight backgrounds while keeping text uniform */
.reg-select .table tbody tr:hover td:first-child,
.reg-select .table tbody tr:focus-within td:first-child {
  background: #e3f3f1;
}

.reg-select .table tbody tr:hover td:nth-child(2),
.reg-select .table tbody tr:focus-within td:nth-child(2) {
  background: #dcdff3;
}

.reg-select .table tbody tr:hover td:last-child,
.reg-select .table tbody tr:focus-within td:last-child {
  background: #cee9e5;
}

/* Selection controls */
.reg-select input[type="radio"] {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 0;

  accent-color: #167b83;
  cursor: pointer;
  vertical-align: middle;
}

.reg-select input[type="radio"]:focus-visible {
  outline: 3px solid #606fac;
  outline-offset: 4px;
  border-radius: 50%;
}

/* Back button */
.btn.btn-info {
  display: inline-block;
  max-width: 100%;
  padding: 14px 24px;

  background: linear-gradient(
      110deg,
      #167b83 0%,
      #5866a3 100%
  );

  border: 0;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(56, 92, 130, 0.24);

  color: #ffffff;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
  white-space: normal;
  cursor: pointer;

  transition:
      filter 0.18s ease,
      box-shadow 0.18s ease;
}

.btn.btn-info:hover {
  filter: brightness(0.9);
  box-shadow: 0 7px 20px rgba(56, 92, 130, 0.30);
  color: #ffffff;
}

.btn.btn-info:focus-visible {
  outline: 3px solid #606fac;
  outline-offset: 4px;
}

/* Mobile layout */
@media (max-width: 600px) {
  .reg-select {
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
    padding: 12px !important;
    border-radius: 14px !important;
  }

  .reg-select .table-responsive {
    border-radius: 11px;
  }

  .reg-select .table-responsive > h3 {
    padding: 18px 14px;
    font-size: 18px;
  }

  .reg-select .table thead th {
    padding: 12px 8px;
    font-size: 10px;
    letter-spacing: 0.02em;
  }

  .reg-select .table thead th:first-child,
  .reg-select .table tbody td:first-child {
    padding-left: 12px;
  }

  .reg-select .table tbody td {
    padding: 17px 8px;
  }

  .reg-select .table thead th:nth-child(2),
  .reg-select .table tbody td:nth-child(2) {
    width: 82px;
  }

  .reg-select .table thead th:last-child,
  .reg-select .table tbody td:last-child {
    width: 44px;
  }

  .reg-select input[type="radio"] {
    width: 22px;
    height: 22px;
  }

  .btn.btn-info {
    width: 100%;
  }
}

.required-field > label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}
</style>
